export default "__VITE_ASSET__CyUOiaNe__"